import script from "./CareerTopComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerTopComponent.vue?vue&type=script&setup=true&lang=js"

import "./CareerTopComponent.vue?vue&type=style&index=0&id=cb4d5a2e&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb4d5a2e"]])

export default __exports__